import React, { FC } from 'react';

import {
  ToggleItem,
  TogglesModal,
  TogglesModalProps,
} from '../toggles-modal/TogglesModal';

export type ChartEvents = 'TMI';

export type EventsConfig = {
  [K in ChartEvents]: boolean;
};

export interface EventsModalLocales {
  title: string;
  event_TMI: string;
}

export interface EventsModalProps {
  onClose: () => void;
  eventsConfig: EventsConfig;
  onChange: TogglesModalProps['onChange'];
  locales: EventsModalLocales;
}

export const EventsModal: FC<EventsModalProps> = ({
  onClose,
  eventsConfig,
  onChange,
  locales,
}) => {
  const items: ToggleItem[] = Object.keys(eventsConfig).map(id => ({
    id,
    label: locales[`event_${id}` as keyof EventsModalLocales],
  }));

  const checkedItems = Object.keys(eventsConfig).reduce((res, key) => {
    if (eventsConfig[key as ChartEvents]) {
      res.push(key);
    }

    return res;
  }, [] as string[]);

  return (
    <TogglesModal
      data-testid="events-modal"
      title={locales.title}
      items={items}
      checkedItems={checkedItems}
      onClose={onClose}
      onChange={onChange}
    />
  );
};
